// ═══════════════════════════════════════════════════════════════════════════════
// Family Member Validation Schemas
// ═══════════════════════════════════════════════════════════════════════════════
import { z } from 'zod';
import { SUPPORTED_LANGUAGES } from '../constants/index.js';
import { uuidSchema } from './common.schema.js';
import { isValidFamilyMemberBirthday } from '../utils/familyMemberBirthday.js';
// ── Create Family Member Input Schema ──
export const createFamilyMemberInputSchema = z.object({
    name: z.string()
        .min(1, 'Name is required')
        .max(100, 'Name must not exceed 100 characters')
        .transform((val) => val.trim()),
    nickname: z.string()
        .max(60, 'Nickname must not exceed 60 characters')
        .default('')
        .transform((val) => val.trim()),
    birthday: z.string()
        .default('')
        .transform((val) => val.trim())
        .refine((val) => isValidFamilyMemberBirthday(val), 'Birthday must be empty, YYYY-MM-DD, or month-day without year (--MM-DD)'),
    remark: z.string()
        .max(2000, 'Remark must not exceed 2000 characters')
        .default('')
        .transform((val) => val.trim()),
    hashtags: z.string()
        .max(500, 'Hashtags must not exceed 500 characters')
        .default('')
        .transform((val) => val.trim()),
    foodPreference: z.string()
        .max(500, 'Food preference must not exceed 500 characters')
        .default('')
        .transform((val) => val.trim()),
    foodAllergy: z.string()
        .max(500, 'Food allergy must not exceed 500 characters')
        .default('')
        .transform((val) => val.trim()),
    medicalCondition: z.string()
        .max(500, 'Medical condition must not exceed 500 characters')
        .default('')
        .transform((val) => val.trim()),
    familyConsentConfirmed: z.boolean().refine((val) => val === true, 'Family consent must be confirmed'),
});
// ── Update Family Member Input Schema (same shape as create; full replace on PUT) ──
export const updateFamilyMemberInputSchema = createFamilyMemberInputSchema;
// ── Family Member ID Param Schema ──
export const familyMemberIdParamSchema = z.object({
    id: uuidSchema,
});
/** Optional viewer UI language for Helper lazy translation on list load. */
export const familyMemberListQuerySchema = z.object({
    viewerLanguage: z.enum(SUPPORTED_LANGUAGES).optional(),
});
//# sourceMappingURL=family.schema.js.map